import { Environment, environment } from '@repo/environment';
import { z } from 'zod';

export const environmentSchema = z.object({
  ENVIRONMENT: z.enum(Environment).default(environment),
});
